import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@material-ui/core';
import * as getTime from '~/skills/getTime';
import PageTitle from '~/components/PageTitle';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Memo, EAA_Input, EAA_Add_Btn, EAA_ErrorText, EAA_Btn } from '~/components/EditAndAddItem';
import { leftColor, rightColor } from '~/components/EditAndAddItem/common';
import SubRent from './SubRent';

const modeInfo = title => ({
  add: {
    title: `${title}新增`,
  },
  edit: {
    title: `${title}編輯`,
  },
  view: {
    title: `${title}檢視`,
  },
});
const titleWidth = 140;
const errorLeft = titleWidth + 20;

const unit = {
  基樁存放: '支',
  '套筒/TP存放': '座',
  塔架存放: '座',
  機艙存放: '座',
  葉片存放: '組',
};

class AddAndEdit extends Component {
  state={ data: {}, old_data: {}, mode: '', canSend: true, errorAry: [] }

  constructor (props) {
    super(props);
    this.state = {
      data: JSON.parse(JSON.stringify(props.data)),
      old_data: JSON.parse(JSON.stringify(props.data)),
      mode: '',
      canSend: true,
      errorAry: [],
    };
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      item_unit: unit[this.props.title],
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  add=() => {
    const { onChange } = this.props;
    onChange(this.state.data);
    this._onClose();
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=() => {
    const { onChange } = this.props;
    onChange(this.state.data);
    this._onClose();
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      // returnInputValue(data.near_land) === '', // 0 存放碼頭-選擇
      // data.near_land === '其他' && returnInputValue(data.near_land_other) === '', // 1 存放碼頭-其他
      // returnInputValue(data.item_num) === '', // 2 數量-輸入
      // false, // returnInputValue(data.item_unit) === '', // 3 數量-單位
      // returnInputValue(data.unit_area) === '', // 4 單位面積
      // returnInputValue(data.expect_space) === '', // 5 預計存放
      // returnInputValue(data.rent_space) === '', // 6 實際租用
      // returnInputValue(data.sign_status) === '', // 7 是否簽約
      // data.sign_status === '1' && returnInputValue(data.rent_start_date) === '', // 8 租賃日期-起始
      // data.sign_status === '1' && returnInputValue(data.rent_end_date) === '', // 9 實際租用-結束
      // data.sign_status === '1' && returnInputValue(data.rent_start_date) !== '' && returnInputValue(data.rent_end_date) !== '' && (getTime.returnDate(data.rent_start_date) > getTime.returnDate(data.rent_end_date)),
      // returnInputValue(data.dock) === '', // 11 港口
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  renderDialog=() => {
    const { mode = '', title = '', PSRent = [], PSPierList = [] } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const disabled = mode === 'view' || isCheck;
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const checkSubChange = (n, ary = []) => isCheck ? JSON.stringify(data[`sub${n}`] || ary) !== JSON.stringify(old_data[`sub${n}`] || ary) : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const allRight = errorAry.indexOf(true) === -1;
    const inputProps = (label = '') => ({
      value: returnInputValue(data[label]),
      onChange: data => this.changeData({ label, data }),
    });
    const checkProps = ({ label = '', value = '' }) => ({
      value: data[label] === value,
      onClick: () => this.changeData({ label, data: value }),
    });
    const dateProps = (label = '') => ({
      value: getTime.returnDate(data[label]),
      onChange: data => this.changeData({ label, data: getTime.getType3Time(data) }),
    });

    const getNearList = () => {
      if (data.dock) {
        for (const o of PSPierList) {
          if (o.value === data.dock) return o.idList;
        }
      }
      return [];
    };

    return (
      <div style={{ width: ' 80%', maxHeight: '80%', backgroundColor: 'white', borderRadius: 39, alignItems: 'center', display: 'flex', flexDirection: 'column', padding: 20, overflowY: 'auto' }}>
        <PageTitle text={modeInfo(title)[mode].title} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='港口' subtitle='' bol />
              <EAA_Select displayBorder disabled={disabled} list={PSPierList} {...inputProps('dock')} onChange={d => this.setState({ data: { ...data, dock: d, near_land: '' } })} />
            </EAA_ItemContainer>
            {errorAry[11] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='存放碼頭之後線暨' subtitle='鄰近土地' subtitleColor='black' haveChange={checkChange('near_land') || checkChange('near_land_other')} />
              <EAA_Select disabled={disabled} displayBorder marginRight={data.near_land === '其他' ? 12 : 50} list={[...getNearList(), { name: '其他', value: '其他' }]} {...inputProps('near_land')} />
              {data.near_land === '其他' && <EAA_Input displayBorder hint='自行新增' {...inputProps('near_land_other')} />}
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇編號' />}
            {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入『新增』' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='數量' haveChange={checkChange('item_num') || checkChange('item_unit')} />
              <EAA_Input displayBorder type='number' {...inputProps('item_num')} unit={unit[title]} />
              {/* <EAA_Select disabled={disabled} displayBorder hint='請選擇單位' list={['單位1', '單位2'].map((o, i) => ({ value: o, name: o }))} {...inputProps('item_unit')} /> */}
            </EAA_ItemContainer>
            {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入『數量』' />}
            {/* {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />} */}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='單位面積需求' haveChange={checkChange('unit_area')} />
              <EAA_Input disabled={disabled} displayBorder type='number' unit={'公頃/單位'} {...inputProps('unit_area')} />
            </EAA_ItemContainer>
            {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='預計存放空間需求' haveChange={checkChange('expect_space')} />
              <EAA_Input displayBorder type='number' unit={'公頃/單位'} {...inputProps('expect_space')} />
            </EAA_ItemContainer>
            {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='實際租用存放空間' haveChange={checkChange('rent_space')} />
              <EAA_Input disabled={disabled} displayBorder type='number' unit='公頃' {...inputProps('rent_space')} />
            </EAA_ItemContainer>
            {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <SubRent {...{ titleWidth, disabled, checkSubChange, changeData: this.changeData, data }} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='是否已完成簽約' haveChange={checkChange('sign_status')} />
              <CircleCheckBox disabled={disabled} {...checkProps({ label: 'sign_status', value: '1' })} />
              <div style={{ marginLeft: 4, marginRight: 8 }}>是</div>
              <CircleCheckBox disabled={disabled} {...checkProps({ label: 'sign_status', value: '2' })} />
              <div style={{ marginLeft: 4 }}>否</div>
            </EAA_ItemContainer>
            {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
          </EAA_Item>
        </EAA_Row>

        {data.sign_status === '1' && (
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} bol text='租賃日期' haveChange={checkChange('sign_status') || checkChange('rent_end_date')} />
                <EAA_Date disabled={disabled} displayBorder hint='起始日期' marginRight={12} {...dateProps('rent_start_date')} />
                <EAA_Date disabled={disabled} displayBorder hint='結束日期' {...dateProps('rent_end_date')} />
              </EAA_ItemContainer>
              {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入『起始日期』' />}
              {errorAry[9] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入『結束日期』' />}
              {errorAry[10] && <EAA_ErrorText marginLeft={errorLeft} text='『起始日期』不可晚於『結束日期』' />}
            </EAA_Item>
          </EAA_Row>
        )}

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='備註' haveChange={checkChange('note')} />
              <EAA_Memo disabled={disabled} displayBorder hint='未簽約說明/預計存放需求大於實際租用空間說明(必填)/其他補充' {...inputProps('note')} />
            </EAA_ItemContainer>
          </EAA_Item>
        </EAA_Row>

        <div style={{ display: 'flex', marginTop: 36, width: '100%', justifyContent: 'center', marginBottom: 40 }}>
          {mode === 'add' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'add' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'add' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'add' && isCheck && <EAA_Btn text='確認新增' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.add} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='確認修改' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.edit} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'view' && <EAA_Btn text='返回' backgroundColor={leftColor} onClick={this._onClose} />}
        </div>
      </div>
    );
  }

  render () {
    return (
      <Dialog
        PaperComponent={this.renderDialog}
        open={true}
      />
    );
  }
}

const mapStateToProps = state => ({
  PSRent: state.data.PSRent,
  PSPierList: state.data.PSPierList,
});
const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
